<script>
export default {
  name: 'ApplicationVettingPlanOutsidePopup',
};
</script>
<script setup>
import BaseConfirmationCard from '@/components/Base/BaseConfirmationCard.vue';
import BaseButton from '@/components/Base/BaseButton.vue';
import BaseIcon from '@/components/Base/BaseIcon.vue';

defineProps({
  vettingPlan: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['go-back', 'proceed']);
</script>
<template>
  <BaseConfirmationCard
    width="480px"
    :on-close="() => emit('go-back')"
  >
    <template #title>
      <div class="flex flex-col gap-4 w-full">
        <div
          class="w-12 h-12 rounded-full bg-proxify-warning-100 flex items-center justify-center"
        >
          <BaseIcon
            name="alert-triangle"
            class="text-proxify-warning-600"
            size="24px"
          />
        </div>
        Move candidate outside the vetting plan?
      </div>
    </template>
    <div class="flex flex-col gap-4 pb-2">
      <p>
        The stage you selected doesn't follow the sequence defined for this
        applicant's vetting plan.
      </p>
      <p class="text-proxify-gray-900 font-semibold">
        {{ vettingPlan.label }}
        <span class="text-proxify-gray-500 font-medium">
          ({{ vettingPlan.name }})
        </span>
      </p>
      <p>
        If you proceed, the applicant's view of the vetting plan won't change.
      </p>
    </div>
    <template #footer>
      <div class="flex flex-row gap-3 p-6 border-t border-proxify-gray-200">
        <BaseButton
          rounded
          class="icon-secondary-gray w-full text-body-md font-semibold"
          data-testid="proceed-anyway-button"
          @click="emit('proceed')"
        >
          Proceed anyway
        </BaseButton>
        <BaseButton
          rounded
          class="icon-primary w-full text-body-md font-semibold"
          data-testid="go-back-button"
          @click="emit('go-back')"
        >
          Go back
        </BaseButton>
      </div>
    </template>
  </BaseConfirmationCard>
</template>
